/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { EmployeeGroupModel } from '../../../../models/employee-group.model';
import { EmployeeModel } from '../../../../models/employee.model';
import { EmployeeService } from '../../../../services/employee.service';
import { SnackbarService } from '../../../../services/snackbar.service';

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.scss'],
  standalone: false
})
export class AddEmployeeComponent implements OnInit, OnDestroy {
  employeeGroupsChangedSubscription: Subscription = new Subscription();
  addEmployeeEmailForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  message: string = '';
  employeeGroups: EmployeeGroupModel[] = [];

  constructor(
    private employeeService: EmployeeService,
    private dialogRef: MatDialogRef<AddEmployeeComponent>,
    private snackbarService: SnackbarService
  ) {}

  ngOnDestroy(): void {
    this.employeeGroupsChangedSubscription.unsubscribe();
  }

  async ngOnInit(): Promise<void> {
    this.employeeGroups = await this.employeeService.getEmployeeGroups();
    this.employeeGroupsChangedSubscription = this.employeeService.employeeGroupsChanged.subscribe(
      (empGroups) => {
        this.employeeGroups = empGroups;
      }
    );
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }

  async onSubmit() {
    const employee: EmployeeModel = {
      employeeId: '',
      name: '',
      email: this.addEmployeeEmailForm.value.email,
      userName: this.addEmployeeEmailForm.value.email,
      employeeGroup: [this.getDefaultEmployeeGroup()],
      startScreenConfiguration: []
    };
    await this.employeeService.addEmployee(employee).then(
      (employeeId) => {
        this.message = 'employee succefully added';
        this.dialogRef.close('success');
      },
      (error) => {
        this.message = error.error.message;
        if (error.status == 402) {
          this.snackbarService.showSnackBar(
            $localize`:Added Users Limit Error Message@@addedUsersLimitErrorMessage:The employee couldn't be added since you have reached your user limit. Please reach out to EPG sales or your person of contact to increase your user limit.`,
            '',
            'error'
          );
        }
      }
    );
  }
  getDefaultEmployeeGroup(): string {
    return this.employeeGroups.find((empGroup) => empGroup.defaultGroup)?.employeeGroupId ?? '';
  }
}
